import React from 'react';
import Icon from '@/components/icon/Icon';
import {  IconsDictionary } from '@/components/icon/Icon.types';
import LoadingSpinner from '@/components/loadingSpinner/LoadingSpinner';
import PlayButtonStyled from './PlayButton.styled';

export interface PlayButtonProps {
  className?: string;
  action: (e?: any) => void;
  isLoading: boolean;
  isDisabled?: boolean;
}

const PlayButton = ({
  className,
  action,
  isLoading,
  isDisabled,
}: PlayButtonProps) => {
  return (
    <PlayButtonStyled
      className={className}
      onClick={() => action()}
      isLoading={isLoading}
      disabled={isDisabled}
    >
      {isLoading && <LoadingSpinner className="play-button__loading-spinner" />}
      <Icon icon={IconsDictionary.Play} className="play-button__icon" />
    </PlayButtonStyled>
  );
};

export default PlayButton;
